require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mineurs-et-spcialisations-2-2-0-0.json") })
        }
      }, "path---mineurs-et-spcialisations-2-2-0-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mineurs-et-spcialisations-2-2-0-0!./.cache/json/mineurs-et-spcialisations-2-2-0-0.json
// module id = 496
// module chunks = 231608221292675